<template>
  <el-card :body-style="{ padding: '20px', height: '100%' }" class="h-full">
    <el-row>
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-select
        size="small"
        filterable
        v-model="classId"
        placeholder="实体类别"
        class="w-200px mr-10px ml-10px"
      >
        <el-option
          v-for="item in classList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="searchTableData">搜索</el-button>
      <el-button size="small" :disabled="!$hasAccess('export')" @click="exportData()"
        >导出</el-button
      >
      <el-button size="small" :disabled="!$hasAccess('export')" @click="exportData('all')"
        >导出全部</el-button
      >
    </el-row>
    <!-- 动态列表格-->
    <el-table
      class="mt-20px"
      ref="table"
      :data="tableData"
      v-loading="tableLoading"
      border
      :highlight-current-row="true"
      height="calc(100% - 106px)"
    >
      <el-table-column
        type="index"
        v-if="!_.isEmpty(tableHeader)"
        width="60"
        :label="`${$t('seqNo')}`"
      ></el-table-column>
      <el-table-column
        v-for="(val, key, index) in tableHeader"
        :prop="key"
        show-overflow-tooltip
        :key="index"
        :label="val"
        min-width="150"
      >
        <template slot-scope="scope">
          <div :class="_.includes(scope.row.markedRedField, key) ? '!text-[#ff0000]' : ''">
            {{ scope.row.data[key] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="mt-20px float-right">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="page.pageNo"
        :page-size="page.pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next"
        :total="page.total"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>
import fnMixin from '@/assets/js/fnMixins'
import ChangeLogService from '@/services/ChangeLogService'
import StdClassTreeService from '@/services/bsApi/StdClassTreeService'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'changeLog',
  components: { selectStandardId },
  mixins: [fnMixin],
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      classId: '',
      tableData: [],
      tableLoading: false,
      tableHeader: {},
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      classList: [],
    }
  },
  watch: {
    classId(newVal) {
      if (newVal) {
        this.searchTableData()
      }
    },
  },
  methods: {
    async exportData(type) {
      const parameter = {
        standardId: this.standardId,
        classId: this.classId,
      }
      if (type) {
        parameter.classId = null
      }
      const res = await ChangeLogService.export(parameter)
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '变更记录导出结果.xlsx',
          data: res,
        })
      }
    },
    async getClassList() {
      const parameter = {
        data_type: 1,
        standard_id: this.standardId,
        subject_domain_id: '',
      }
      const res = await StdClassTreeService.getTreeList(parameter)
      if (res && res.code === 0 && res.data) {
        // 过滤出已经发布的实体
        this.classList = res.data.filter((item) => {
          return item.approveStatus === 1
        })
        if (this.classList.length > 0) {
          this.classId = this.classList[0].id
        }
      }
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.searchTableData()
    },
    updateStandardId(val) {
      this.standardId = val
      this.classId = null
      this.getClassList()
    },
    async searchTableData() {
      await this.getTableHeader()
      const res = await ChangeLogService.getChangeListByClass({
        standardId: this.standardId,
        classId: this.classId,
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        sorting: '',
      })
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })
      }
    },
    async getTableHeader() {
      const res = await ChangeLogService.getChangeListByClassHeader({
        standardId: this.standardId,
        classId: this.classId,
      })
      if (res && res.code === 0) {
        this.tableHeader = res.data
      }
    },
  },
  async created() {
    await this.getClassList()
    this.searchTableData()
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
}
</script>
